import { Page } from '@/components/layout/page/page.tsx'

export const ResourceNotFound = () => {
  return (
    <Page>
      <div className="flex flex-col items-center justify-center h-full gap-4">
        <div className="text-4xl font-bold">404</div>
        <div className="text-xl">Resource not found</div>
      </div>
    </Page>
  )
}
